<script>
    import { createEventDispatcher } from 'svelte';

    // Declare the dispatcher
    const dispatch = createEventDispatcher();

    //PROPS
    export let secondBrandTitle = '';
    export let secondBrandMessage = '';
    export let partnerBrandTitle = '';
    export let partnerBrandMessage = '';
    export let partnerBrandAgreementMessage = '';
    export let secondBrandAgreementMessage = '';
    export let p2Dyn = false;
    export let p2DynNeutral = false;

    //METHODS
    const changeSecondBrand = (value) => {
        dispatch('secondBrand', value);
    };
    const changePartnerOptin = (value) => {
        dispatch('partnerOptin', value);
    };

    //FLAGS FOR THE TOOLTIPS
    let showTooltip = false;
    let showPartnerTooltip = false;
</script>

<!-- ======================== HTML TEMPLATE ================================= -->
{#if (!!secondBrandTitle && !!secondBrandMessage && !p2Dyn && !p2DynNeutral) || (!!partnerBrandTitle && !!partnerBrandMessage)}
    <div class="app-msi_form-check">
        <fieldset class="app-msi_second-brand">
            {#if secondBrandTitle && !p2Dyn && !p2DynNeutral}
                <legend>{secondBrandTitle}</legend>
            {/if}
            {#if (!secondBrandTitle || p2Dyn || p2DynNeutral) && partnerBrandTitle}
                <legend>{partnerBrandTitle}</legend>
            {/if}
            {#if !!secondBrandTitle && !!secondBrandMessage && !p2Dyn && !p2DynNeutral}
                <input
                    class="app-msi_form-check-input"
                    type="checkbox"
                    on:click={(event) => changeSecondBrand(event.target.checked)}
                    id="secondBrand"
                />
                <label class="app-msi_form-check-label" for="secondBrand">
                    {secondBrandMessage}
                </label>
                <div
                    class="app-msi_form-tooltip"
                    on:click={() => {
                        showTooltip = !showTooltip;
                    }}
                >
                    <span>?</span>
                </div>
            {/if}
            {#if !!partnerBrandTitle && !!partnerBrandMessage}
                <div>
                    <input
                        class="app-msi_form-check-input"
                        type="checkbox"
                        on:click={(event) => changePartnerOptin(event.target.checked)}
                        id="partnerOptin"
                    />
                    <label class="app-msi_form-check-label" for="partnerOptin">
                        {partnerBrandMessage}
                    </label>
                    {#if !!partnerBrandAgreementMessage}
                        <div
                            class="app-msi_form-tooltip"
                            on:click={() => {
                                showPartnerTooltip = !showPartnerTooltip;
                            }}
                        >
                            <span>?</span>
                        </div>
                    {/if}
                </div>
            {/if}
        </fieldset>
        {#if showTooltip && secondBrandAgreementMessage && !p2Dyn && !p2DynNeutral}
            <span class="app-msi_tooltip-message">
                {@html secondBrandAgreementMessage}
            </span>
        {/if}
        {#if showPartnerTooltip && partnerBrandAgreementMessage}
            <span class="app-msi_tooltip-message">
                {@html partnerBrandAgreementMessage}
            </span>
        {/if}
    </div>
{/if}
